import React, { createContext, useContext, Dispatch, SetStateAction, useState } from 'react';

export interface MortgageProps {
  name: string;
  colour: string;
  yearlyData: number[];
  monthlyData: number[];
  totalInterestPaidPerYear: number[];
  totalInterestPaidPerMonth: number[];
  totalAmountPaidPerYear: number[];
  totalAmountPaidPerMonth: number[];
  amountPaidYearly: number[];
  amountPaidMonthly: number[];
  interestAddedYearly: number[];
  interestAddedMonthly: number[];
  monthlyPayment: number;
  totalInterest: number;
  totalAmountPaid: number;
}

export const initialMortgageState: MortgageProps = {
  name: "",
  colour: "rgba(255, 99, 132, 1)",
  yearlyData: [],
  monthlyData: [],
  totalInterestPaidPerYear: [],
  totalInterestPaidPerMonth: [],
  totalAmountPaidPerYear: [],
  totalAmountPaidPerMonth: [],
  amountPaidYearly: [],
  amountPaidMonthly: [],
  interestAddedYearly: [],
  interestAddedMonthly: [],
  monthlyPayment: 0,
  totalInterest: 0,
  totalAmountPaid: 0,
};

const MortgageContext = createContext({
  state: initialMortgageState as MortgageProps,
  setState: {} as Dispatch<SetStateAction<MortgageProps>>
});

const MortgageContextProvider = ({
  children,
  value = {} as MortgageProps,
}: {
  children: React.ReactNode;
  value?: MortgageProps;
}) => {
  const [state, setState] = useState(value);

  return (
    <MortgageContext.Provider value={{ state, setState }}>
      {children}
    </MortgageContext.Provider>
  );
};

const useMortgageContext = () => {
  const context = useContext(MortgageContext);
  if (!context) {
    throw new Error('useMortgageContext must be used within a MortgageContext');
  }
  return context;
};

export { MortgageContextProvider, useMortgageContext };